import type * as Types from '../generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type TrackImpactRadiusMutationVariables = Types.Exact<{
  payload: Types.ImpactRadiusTrackingPayload;
}>;

export type TrackImpactRadiusMutation = { __typename?: 'Mutation'; trackImpactRadius?: boolean | null };

export const TrackImpactRadiusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TrackImpactRadius' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ImpactRadiusTrackingPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackImpactRadius' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TrackImpactRadiusMutationFn = Apollo.MutationFunction<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>;

/**
 * __useTrackImpactRadiusMutation__
 *
 * To run a mutation, you first call `useTrackImpactRadiusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackImpactRadiusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackImpactRadiusMutation, { data, loading, error }] = useTrackImpactRadiusMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTrackImpactRadiusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>) {
  return ApolloReactHooks.useMutation<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>(TrackImpactRadiusDocument, baseOptions);
}
export type TrackImpactRadiusMutationHookResult = ReturnType<typeof useTrackImpactRadiusMutation>;
export type TrackImpactRadiusMutationResult = Apollo.MutationResult<TrackImpactRadiusMutation>;
export type TrackImpactRadiusMutationOptions = Apollo.BaseMutationOptions<TrackImpactRadiusMutation, TrackImpactRadiusMutationVariables>;
